import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 52px;
  background-color: ${buildColor("white", "900")};
  border-bottom: 1px solid ${buildColor("blue", "100")};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${buildColor("blue_accent", "000")};
  }

  &:active {
    background-color: ${buildColor("blue", "000")};
  }
`;

export const ClickableArea = styled.div`
  background: none;
  display: block;
  cursor: pointer;
  width: 100%;
  position: relative;
  padding-right: 32px;
`;

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  position: absolute;
  right: 8px;
  pointer-events: none;
`;
